import * as React from "react";
import { forwardRef } from "react";
const SvgCaretDownFill = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", stroke: "currentColor", strokeLinejoin: "round", d: "M5.5 9h13L12 16z" }));
const ForwardRef = forwardRef(SvgCaretDownFill);
export default ForwardRef;
